import * as angular from 'angular';

import { NgZone } from '@angular/core';

export const InPlaceEditDirective: angular.IDirectiveFactory = function (
  $timeout: angular.ITimeoutService,
  ngZone: NgZone
) {
  return {
    restrict: 'E',

    template: `<div class="in-place-edit">
        <div class="in-place-edit-text" ng-click="!noEdit && startEditText();" ng-hide="editing" ng-class="{empty: !text}">
          <i class="icon-action-edit-default" ng-hide="noEdit"></i>{{ noEdit ? text : (text || altText || 'Click to add text') }}
        </div>
        <div class="in-place-edit-form" ng-show="editing">
          <input type="text" maxlength="250" class="in-place-edit-input" ng-model="value" ng-blur="endEditText()" />
        </div>
       </div>`,

    scope: {
      text: '=',
      altText: '@',
      onChange: '&',
      // legacy callback
      onUpdate: '&',
      noBlank: '=',
      noEdit: '=',
    },

    link: function ($scope: any, $elem) {
      const $input = $($elem).find('.in-place-edit-input');

      ngZone.runOutsideAngular(() => {
        function resizeInput() {
          $input.attr('size', $input.val().length + 6); // Some padding incase a lot of wide letters are used
        }

        $input.on('keydown focus input propertychange change', resizeInput).each(resizeInput);

        $scope.startEditText = function () {
          if ($scope.noEdit) {
            return;
          }

          $scope.editing = true;
          $scope.value = $scope.text;
          $timeout(function () {
            $input.on('keypress.enterblur', function (e) {
              const code = e.keyCode || e.which;
              if (code === 13) {
                // enter
                $input.blur();
              }
            });
            $input.on('keyup', function (e) {
              // escape
              if (e.which === 27) {
                $scope.$evalAsync(function () {
                  $scope.value = $scope.text;
                  $scope.endEditText(); // calling .blur() won't fire endEditText due to the way escape works
                });
              }
            });
            $input.focus();
            $input.select();
          });
        };

        $scope.endEditText = function () {
          $input.off('keypress.enterblur');
          $input.off('keyup');

          $scope.editing = false;
          if ($scope.noBlank && !$scope.value) {
            $scope.value = $scope.text;
            return;
          }

          if ($scope.value !== $scope.text) {
            $scope.onChange({ $text: $scope.value });
            // keeping onUpdate for backwards compatibility
            if (typeof $scope.onUpdate() === 'function') {
              $scope.onUpdate()($scope.value);
              console.warn('inPlaceEditDirective::onUpdate is deprecated. Please use "onEdit" instead');
            }
          }
        };
      });
    },
  };
};

InPlaceEditDirective.$inject = ['$timeout', 'NgZone'];
